function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Response } from "miragejs";
import createFieldResolver from "./resolvers/field-mjs";
import { ensureExecutableGraphQLSchema } from "./utils-mjs";
import { ensureModels } from "./orm/models-mjs";
import { graphql } from "graphql";
export function createGraphQLHandler(graphQLSchema, mirageSchema) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$context = _ref.context,
      context = _ref$context === void 0 ? {} : _ref$context,
      resolvers = _ref.resolvers,
      root = _ref.root;

  var contextValue = _objectSpread(_objectSpread({}, context), {}, {
    mirageSchema: mirageSchema
  });

  var fieldResolver = createFieldResolver(resolvers);
  graphQLSchema = ensureExecutableGraphQLSchema(graphQLSchema);
  ensureModels({
    graphQLSchema: graphQLSchema,
    mirageSchema: mirageSchema
  });
  return function graphQLHandler(_mirageSchema, request) {
    try {
      var _JSON$parse = JSON.parse(request.requestBody),
          query = _JSON$parse.query,
          variables = _JSON$parse.variables;

      return graphql({
        contextValue: _objectSpread(_objectSpread({}, contextValue), {}, {
          request: request
        }),
        fieldResolver: fieldResolver,
        rootValue: root,
        schema: graphQLSchema,
        source: query,
        variableValues: variables
      });
    } catch (ex) {
      return new Response(500, {}, {
        errors: [ex]
      });
    }
  };
}
